 <template>
	<div class="csoportkezelese">
	    <v-app id="csoportkezeles">
	    	<v-tabs grow>
	    		<v-tab>
		          Felhasználók
		        </v-tab>
		        <v-tab-item>
		        	<v-data-table
				      :headers="tablazat.fejlecek"
				      :items="tablazat.felhasznalok"
				      sort-by="nev"
				      class="elevation-1"
				      :search="tablazat.kereses"
				    >
				      <template v-slot:top>
				        <v-toolbar flat color="white">
				        	<v-text-field
						          v-model="tablazat.kereses"
						          label="Keresés"
						          single-line
						          hide-details
						        ></v-text-field>
						        <v-divider
						            class="mx-4"
						            inset
						            vertical
						          ></v-divider>
				          <v-dialog v-model="felugroablak" max-width="500px">
				            <template v-slot:activator="{ on }">

				              <v-btn color="primary" dark class="mb-2" v-on="on">Új felhasználó</v-btn>
				               
				            </template>
				            <v-card>
				              <v-card-title>
				                <span class="headline">{{ felugroablakcimsor }}</span>
				              </v-card-title>
				  
				              <v-card-text>
				                <v-container>
				                  <v-row>
				                    <v-col cols="12" sm="6" md="4">
				                      <v-text-field v-model="szerkesztettelem.nev" label="Név"></v-text-field>
				                    </v-col>
				                    <v-col cols="12" sm="6" md="4">
				                      <v-text-field v-model="szerkesztettelem.email" label="Email-cím"></v-text-field>
				                    </v-col>
				                    <v-col cols="12" sm="6" md="4">
				                      <v-text-field type="password" v-model="szerkesztettelem.jelszo" label="Jelszó"></v-text-field>
				                    </v-col>
				                    <v-col cols="12" sm="6" md="4">
				                      <v-text-field type="password" v-model="szerkesztettelem.jelszomegegyszer" label="Jelszó ismétlése"></v-text-field>
				                    </v-col>
				                    <v-col cols="12" sm="6" md="4">
				                      <!--<v-text-field v-model="editedItem.protein" label="Protein (g)"></v-text-field>-->
				                    </v-col>
				                  </v-row>
				                </v-container>
				              </v-card-text>
				  
				              <v-card-actions>
				                <v-spacer></v-spacer>
				                <v-btn color="blue darken-1" text @click="bezaras">Bezárás</v-btn>
				                <v-btn color="blue darken-1" text @click="mentes">Mentés</v-btn>
				              </v-card-actions>
				            </v-card>
				          </v-dialog>
				        </v-toolbar>
				      </template>
				      <template v-slot:item.muveletek="{ item }">
				      	<v-btn color="blue darken-1" text @click="szerkesztes(item)">Szerkesztés</v-btn>
				 		<v-btn color="red darken-1" text @click="torles(item)">Törlés</v-btn>
				        <!--<v-icon
				          small
				          class="mr-2"
				          @click="editItem(item)"
				        >
				          edit
				        </v-icon>
				        <v-icon
				          small
				          @click="deleteItem(item)"
				        >
				          delete
				        </v-icon>-->
				      </template>
				      <template v-slot:item.admin="{item}">
				      	<v-checkbox
				      		readonly
				     		v-model="item.admin"
				     		:ripple="false"
				      	></v-checkbox>
				      </template>
				    </v-data-table>
  		        </v-tab-item>
	    	</v-tabs>

	      <v-snackbar
	        v-model="snackbar.megnyit"
	      >
	        {{ snackbar.szoveg }}
	        <v-btn
	          color="pink"
	          text
	          @click="snackbar.megnyit = false"
	        >
	          Bezár
	        </v-btn>
	      </v-snackbar>
	    </v-app>
	</div>

</template>

<script>
     import router from "../router"

export default {
  components: {
  },
  data: function () {
  	return {
  		snackbar: {
  			megnyit: false,
  			szoveg: 'Nem számot adott meg!'
  		},
  		tablazat: {
  			fejlecek: [
  				{
  					text: 'Név',
  				  	align: 'left',
  				  	value: 'nev'
  				},
  				{
  					text: 'Email cím',
  					value: 'email'
  				},
  				{
  					text: 'Regisztráció dátuma',
  					value: 'regdatum'
  				},
  				{
  					text: 'Admin',
  					value: 'admin',
  					sortable: false
  				},
  				{
  					text: 'Műveletek',
  					value: 'muveletek',
  					sortable: false,
  					align: 'center '
  				}
  			],
  			felhasznalok:[],
  			kereses:''
  		},
  		felugroablak: false,
  		szerkesztettelem: {
  			id: -1,
  			nev:'',
  			email:'',
  			jelszo:'',
  			jelszomegegyszer:'',
  			admin:false
  		}
  	}
  },
  computed: {
	felugroablakcimsor(){
		if(this.szerkesztettelem.id>-1){
			return 'Felhasználó szerkesztése';
		}
		else{
			return 'Felhasználó létrehozása';
		}
	}
  },
  watch: {
  	felugroablak(ertek){
  		if(!ertek){
  			this.bezaras();
  		}
  	}
  },
  methods: {
  	kijelentkezes: function(){
  		this.$store.commit('bejelentkezve', false)
            router.push('/bejelentkezes');
            this.$store.commit('admin',false)
        },
  	objektumatadas: function (objektum) {
  		return JSON.parse(JSON.stringify(objektum))
  	},
  	mentes: function() {
  		if(this.szerkesztettelem.nev!='' && this.szerkesztettelem.email!='' && this.szerkesztettelem.jelszo==this.szerkesztettelem.jelszomegegyszer){
  			if(this.szerkesztettelem.id>-1){
  				this.axios.put(this.$store.state.backendeleres+"admin/felhasznalok/"+this.szerkesztettelem.id,{email:this.szerkesztettelem.email,jelszo:this.szerkesztettelem.jelszo,jelszoismetles:this.szerkesztettelem.jelszomegegyszer,nev:this.szerkesztettelem.nev}).then((response) =>{
  					if(response.data.sikeresmodositas){
  						var eredetiszerkesztettelem = this.tablazat.felhasznalok.find((eredetifelhasznalo) =>{
  							return eredetifelhasznalo.id==this.szerkesztettelem.id;
  						})
  						eredetiszerkesztettelem.nev=this.szerkesztettelem.nev;
  						eredetiszerkesztettelem.email=this.szerkesztettelem.email;
  						eredetiszerkesztettelem.admin=this.szerkesztettelem.admin;
  						this.bezaras()
  					}
  					else{
  						this.snackbar.szoveg=response.data.hiba;
	  				  	this.snackbar.megnyit=true;
  					}
  					if(response.data.bejelentkezve==false){
			            this.kijelentkezes()
			        }
  				})
	  		}
	  		else{
	  			if(this.szerkesztettelem.jelszo!='')
	  			{
	  				this.axios.post(this.$store.state.backendeleres+"admin/felhasznalok",{email: this.szerkesztettelem.email,jelszo:this.szerkesztettelem.jelszo,jelszoismetles: this.szerkesztettelem.jelszomegegyszer,nev: this.szerkesztettelem.nev}).then((response) =>{
	  				  				if(response.data.sikereshozzaadas){
	  				  					this.tablazat.felhasznalok.push({id: response.data.id, nev:this.szerkesztettelem.nev, email: this.szerkesztettelem.email, admin: this.szerkesztettelem.admin,regdatum:"Ebben a munkamenetben"});
	  				  					this.bezaras()
	  				  				}
	  				  				else{
	  				  					this.snackbar.szoveg=response.data.hiba;
	  				  					this.snackbar.megnyit=true;
	  				  				}
	  				  				if(response.data.bejelentkezve==false){
							            this.kijelentkezes()
							        }
	  				  			})
	  			}
	  			else{
	  				this.snackbar.szoveg="Töltsön ki minden mezőt helyesen!";
  					this.snackbar.megnyit=true;
	  			}
	  		}
  		}
  		else{
  			if(this.szerkesztettelem.nev==''||this.szerkesztettelem.email==''||this.szerkesztettelem.jelszomegegyszer==''||this.szerkesztettelem.jelszo=='' ){
  				this.snackbar.szoveg="Töltsön ki minden mezőt helyesen!";
  				this.snackbar.megnyit=true;
  			}
  			if(this.szerkesztettelem.jelszo!=this.szerkesztettelem.jelszomegegyszer){
  				this.snackbar.szoveg="A két megadott jelszó nem egyezik";
  				this.snackbar.megnyit=true;

  			}
  		}
  		
  	},
  	bezaras: function(){
  		this.szerkesztettelem.id=-1;
  		this.szerkesztettelem.nev='';
  		this.szerkesztettelem.email='';
  		this.szerkesztettelem.jelszo='';
  		this.szerkesztettelem.jelszomegegyszer='';
  		this.admin=false;
  		this.felugroablak=false;
  	},
  	szerkesztes: function(elem){
  		this.szerkesztettelem.id=elem.id;
  		this.szerkesztettelem.nev=elem.nev;
  		this.szerkesztettelem.email=elem.email;
  		this.felugroablak=true;
  		this.szerkesztettelem.admin=elem.admin==1;
  	},
  	torles:function(elem){

  	}
  },
  mounted () {
  	this.axios.get(this.$store.state.backendeleres+"admin/felhasznalok").then((response) =>{
  		this.tablazat.felhasznalok=response.data.felhasznalok;
  		if(response.data.bejelentkezve==false){
            this.kijelentkezes()
        }
  	})
  }
}
</script>
